if(document.querySelectorAll(".m-main-lead__button-wrap a.e-button.e-cta-button").length > 0) {
  // Step 1: Get the subscriberKey and opportunityid from the current page's URL
  const urlParams = new URLSearchParams(window.location.search);
  const opportunityId = urlParams.get('opportunityid');
  const subscriberKey = urlParams.get('mcparam');

  // Step 2: Select all buttons with the given class name
  const contractButtons = document.querySelectorAll(".m-main-lead__button-wrap a.e-button.e-cta-button");

  // Step 3: Add the subscriberkey and opportunityid parameters to each button's href
  if (subscriberKey && opportunityId) {
    contractButtons.forEach((button) => {
      const existingUrl = new URL(button.href);
      existingUrl.searchParams.set('mcparam', subscriberKey); // Set the subscriberkey parameter
      existingUrl.searchParams.set('opportunityid', opportunityId); // Set the opportunityid parameter
      button.href = existingUrl.toString(); // Update the button's href
    });
  }
}